import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { getHomeData } from '../../actions/contentActions.js'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import Platform from '../../platforms/index.js'
import { LocalizeStationStep } from '../../reducers/types/reducerTypes'
import { store } from '../../store.js'
import { useAppSelector } from '../../hooks/useStore'
import { HomeScreenState } from './types'

const useHomeScreenLogic = () => {
  const navigate = useNavigate()

  // Redux selectors
  const stationId = useAppSelector((state) => state.station.station_id)
  const UID = useAppSelector((state) => state.device.UID)
  const homeCollections = useAppSelector(
    (state) => state.homeContent.collections
  )
  const localizeStationStep = useAppSelector(
    (state) => state.station.localize_station_step
  )
  const deeplinkUrl = useAppSelector((state) => state.deepLink?.url)

  const [state, setState] = useState<HomeScreenState>({
    collections: null,
    collectionsReady: false,
    toggleMessageUI: false,
    toggleLocalizeModal: false,
  })

  const prepareHomeContent = () => {
    const hasHomeContent =
      Array.isArray(homeCollections) && homeCollections.length > 0

    if (hasHomeContent) {
      setState((prev) => ({
        ...prev,
        collections: homeCollections,
        collectionsReady: true,
      }))
    }
  }

  const handleCloseModal = () => {
    setState((prev) => ({ ...prev, toggleMessageUI: false }))
    Platform.userSawMessage = true
  }

  const handleDismissLocalizeModal = () => {
    setState((prev) => ({
      ...prev,
      toggleLocalizeModal: false,
    }))
    store.dispatch({
      type: 'UPDATE_LOCALIZATION_STEP',
      payload: LocalizeStationStep.COMPLETED,
    })

    if (deeplinkUrl) {
      navigate(deeplinkUrl)
    }
  }

  // componentDidMount logic
  useEffect(() => {
    Platform.reportAppReady()

    if (!Array.isArray(homeCollections)) {
      getHomeData(stationId, UID)
    }

    // When you navigate from Shows to Home in the SidePanel,
    // you need to update the states to display the content.
    prepareHomeContent()

    googleAnalytics4.sendPageViewEvent('Home')

    if (
      !Platform.userSawMessage &&
      Platform.getMessageValidations().isValid &&
      Platform.isMessageAvailableForEnv()
    ) {
      // Send GA analytics ? Send mux event ?
      setState((prev) => ({
        ...prev,
        toggleMessageUI: true,
      }))
    }

    if (localizeStationStep === LocalizeStationStep.RELOCALIZING) {
      setState((prev) => ({
        ...prev,
        toggleLocalizeModal: true,
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // componentDidUpdate logic
  useEffect(() => {
    prepareHomeContent()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeCollections])

  const isDoneFetching = () => state.collectionsReady

  return {
    ...state,
    handleCloseModal,
    handleDismissLocalizeModal,
    isDoneFetching,
  }
}

export default useHomeScreenLogic
